import { Box, Button, MenuItem, InputLabel, FormControl, TextareaAutosize, TextField, Select, Checkbox, Autocomplete } from '@mui/material'
import { FC, useEffect, useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { ProductoI } from '../../../models/productos'
import useProductoAdd from './useProductoAdd'
import CustomTextArea from '../../Custom/TextArea'
import ImageDropzone from '../UploadImage'
import MultiImageDropzone from '../UploadImage/MultiplesImages'
import useDescargableAdd from '../../Descargables/Add/useDescargableAdd'
import { DescargableI } from '../../../models/descargables'
import { CATEGORIAS_DESCARGABLES, LABELS_DESCARGABLES, SELECT_CATEGORIAS_PRODUCTOS, SELECT_SUBCATEGORIAS_PRODUCTOS } from '../../../constants/Select'
import useFetchDescargables from '../../../hooks/useFetchDescargables'
import { useDescargablesContext } from '../../../context/DescargablesContext'

interface Props {
    producto?: ProductoI,
    descargable?: DescargableI,
}

const ProductoAdd: FC<Props> = ({ producto, descargable }) => {

    const { onChange, handleSubmit, formData, setFormData, handleImageFieldChange, removeImagen, removeImagenPequena, loading
     } = useProductoAdd(producto)
     const categoriasProductos = SELECT_CATEGORIAS_PRODUCTOS
     const subcategoriasProductos = SELECT_SUBCATEGORIAS_PRODUCTOS
     useFetchDescargables()
     const { descargables } = useDescargablesContext()
     const [SkuInicial, setSkuInicial] = useState(descargable?.sku)
     const [IdInicial, setIdInicial] = useState(descargable?.id)
     const [busquedaDescargable, setBusquedaDescargable] = useState('')
    const [checkPersonalizado, setCheckPersonalizado] = useState(false)

    const descargablesFiltrados = useMemo(() => {
        if (!descargables) return []
        
        return descargables.filter(d => {
            if (!d.activo) return false
            if (d?.sku && d.sku !== producto?.sku) return false
            
            if (!busquedaDescargable.trim()) return true
            if (!d?.titulo.trim()) return false
            
            const titulo = (d?.titulo || '').toLowerCase()
            const busqueda = busquedaDescargable.toLowerCase()
            
            return titulo.includes(busqueda)
        })
        
    }, [descargables, producto?.sku, busquedaDescargable])

     
     const { 
        formData:formDataDescargable, 
        setFormData:setFormDataDescargable,
        handleDeleteRelatedDescargable
      } = useDescargableAdd({navigation: true})

    const navigate = useNavigate()

    const handleSubmitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        await handleSubmit(e)

        if(!formDataDescargable) return


        if(IdInicial && ( IdInicial !== formData.idDescargable)){

            handleDeleteRelatedDescargable({sku:"", id:IdInicial || ''})
        }

        if( formData?.sku){
            await handleDeleteRelatedDescargable({sku:formData.sku, id:formData.idDescargable})
        }

        navigate('/productos')

    }

    
    const handleDeleteDescargable = async () => {

        if(!IdInicial || !SkuInicial) return 

        if (!window.confirm('¿Borrar Descargable?')) return

        handleDeleteRelatedDescargable({sku:SkuInicial || '', id:IdInicial || ''})

        alert("Descargable eliminado")

        navigate('/productos')
        
    }

    useEffect(() => {

        setFormDataDescargable(prev => ({
            ...prev,
            titulo: descargable?.titulo || '',
            descripcion_breve: descargable?.descripcion_breve || '',
            img_thumb: descargable?.img_thumb || '',
            descargar_pdf: descargable?.descargar_pdf || '',
            categorias: 'Manuales y Garantias',
            restringido: false,
            path_img_thumb:descargable?.path_img_thumb || '',
            path_descargar_pdf:descargable?.path_descargar_pdf || '',
            sku:descargable?.sku || producto?.sku || '',
            id:descargable?.id || ''
        }))

        setSkuInicial(descargable?.sku)
        setIdInicial(descargable?.id)

    }, [descargable])

    useEffect(() => {

        setFormDataDescargable(prev => ({
            ...prev,
            sku:producto?.sku || ''
        }))


        if(formData.labelDescargable === 'Descargables'){
            setFormData(prev => ({
                ...prev,
                idDescargable: ''
            }))
        }


    }, [formData.sku, formData.labelDescargable])
    
    useEffect(() => {

        if(!formData?.labelDescargable) return
        
        const labelDescargable = LABELS_DESCARGABLES.find(label => label === formData?.labelDescargable)

        if(labelDescargable){
            setCheckPersonalizado(false)
        }
        else{
            setCheckPersonalizado(true)
        }

    }, [producto])


    return (
        <>

            <Box component='form' onSubmit={handleSubmitForm} style={{
                display: "flex",
                flexDirection: "column",
                gap: 20,
                background: '#fff',
                padding: '4%',
                paddingBottom: '10%',
            }}>

                <h1 className='text-4xl font-bold'>Producto - {producto?.nombre || "Nuevo"}</h1>

                <h2 className='text-2xl font-bold'>Presentacion</h2>
                
                <InputLabel>Descripcion</InputLabel>
                <CustomTextArea value={formData.descripcion} carpeta="Productos"
                onChange={(e) => {
                    setFormData(prev => ({
                    ...prev,
                    descripcion: e
                    }))
                }} />

                <TextField label="SKU" variant='outlined' value={formData.sku} name="sku" onChange={onChange} style={{ background: '#fff' }} required />
                <TextField label="Link Amazon" variant='outlined' value={formData.link_amazon} name="link_amazon" onChange={onChange} style={{ background: '#fff' }}  />
                <TextField label="Link Mercado Libre" variant='outlined' value={formData.link_ml} name="link_ml" onChange={onChange} style={{ background: '#fff' }} />

                <MultiImageDropzone
                    imagenes={formData.productos_imagenes}
                    handleImageFieldChange={handleImageFieldChange}
                    name="productos_imagenes"
                    setImagenes={(imgs: any) =>
                        setFormData((prev) => ({
                        ...prev,
                        productos_imagenes: imgs,
                        }))
                    }
                    title='Imagenes'
                    onRemove={removeImagen}
                />

                <h2 className='text-2xl font-bold'>Video</h2>

                <FormControl>
                  <TextField label="Link Video" variant='outlined' 
                  value={formData.video} name="video" onChange={onChange} style={{ background: '#fff' }} />

                </FormControl>

                <h2 className='text-2xl font-bold'>Generales</h2>

                <FormControl>
                    <InputLabel>Activo</InputLabel>
                    <Checkbox checked={formData.activo} onChange={() => {
                        setFormData(prev=>({
                            ...prev,
                            activo: !prev.activo
                        }))
                    }} />
                </FormControl>

                
                <FormControl>
                    <InputLabel>Destacado</InputLabel>
                    <Checkbox checked={formData.destacado} onChange={() => {
                        setFormData(prev => ({
                            ...prev,
                            destacado: !prev.destacado
                        }))
                    }} />
                </FormControl>

                <TextField label="Nombre" variant='outlined' value={formData.nombre} name="nombre" onChange={onChange} style={{ background: '#fff' }} required />

                <InputLabel>Meta Tags</InputLabel>
                <TextareaAutosize
                    aria-label="empty textarea"
                    placeholder="Meta tags"
                    minRows={5}
                    style={{ width: '100%', padding: '5px' }}
                    value={formData.meta_tags}
                    name="meta_tags" onChange={onChange}
                    className='border border-gray-300 rounded-md p-2'
                />

                <FormControl>
                    <InputLabel >Categorias</InputLabel>
                    <Select  name="categoria" onChange={onChange} value={formData.categoria}>
                        {categoriasProductos.map((categoria, index) => (
                            <MenuItem key={index} value={categoria}>{categoria}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

               {/* <FormControl>
                    <InputLabel>Subcategoria</InputLabel>
                    <Select name="subcategoria" onChange={onChange} value={formData.subcategoria}>
                        <MenuItem value="">Selecciona una subcategoria</MenuItem>
                        {subcategoriasProductos.map((subcategoria, index) => (
                            <MenuItem key={index} value={subcategoria}>{subcategoria}</MenuItem>
                        ))}
                    </Select>
                </FormControl>*/}

                <InputLabel >Imagen principal</InputLabel>
                <div className="  mb-8">
                    
                    <ImageDropzone image={formData.imagen_principal || null} onChange={e => {
                       setFormData(prev => ({
                        ...prev,
                        imagen_principal: e.target.files ? e.target.files[0] : null
                    }))
                    }} title='Imagen principal ' img={formData.imagen_principalUrl} />

                </div>
               
                <h2 className='text-2xl font-bold'>Infografía</h2>
                <div className="  mb-8">
                    
                    <ImageDropzone image={formData.infografia || null} onChange={e => {
                       setFormData(prev => ({
                        ...prev,
                        infografia: e.target.files ? e.target.files[0] : null
                    }))
                    }} title='Infografía' img={formData.infografiaUrl} />
                </div>


                <h2 className='text-2xl font-bold'>Complementario</h2>

                <div className="  mb-8">
                    
                    <ImageDropzone image={formData.imagen_complementaria} onChange={e => {
                        setFormData(prev => ({
                            ...prev,
                            imagen_complementaria: e?.target?.files ? e.target.files[0] : null
                        }))
                    }} title='Imagen Complementaria (1400 x 1110)'  img={formData.imagen_complementariaUrl} />
                </div>
                <TextField label="Titulo Complementario" variant='outlined' value={formData.titulo_complementario} name="titulo_complementario" onChange={onChange} style={{ background: '#fff' }} />
                <TextareaAutosize
                    aria-label="Descripcion Complementaria"
                    placeholder="Descripcion Complementaria"
                    minRows={5}
                    style={{ width: '100%', padding: '5px', fontWeight: 'normal' }}
                    value={formData.descripcion_complementaria}
                    name="descripcion_complementaria" onChange={onChange}
                    className='border border-gray-300 rounded-md p-2 '
                />


                <h2 className='text-2xl font-bold'>Imagenes Pequeñas</h2>
                <MultiImageDropzone
                    handleImageFieldChange={handleImageFieldChange}
                    name="productos_imagenes_pequenas"
                    imagenes={formData.productos_imagenes_pequenas}
                    setImagenes={(imgs: any) =>
                        setFormData((prev) => ({
                        ...prev,
                        productos_imagenes_pequenas: imgs,
                        }))
                    }
                    title='Imagenes Pequeñas'
                    onRemove={removeImagenPequena}
                />


                <div className='flex gap-3 justify-between'>
                    <h2 className='text-2xl font-bold'>Descargable</h2>

                    <Button color="success" variant="contained" disabled={!descargable?.id} onClick={handleDeleteDescargable} style={{
                        background: '#000',
                        fontFamily: 'WorkSans',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '16px',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        color: '#FFF',
                        padding: '17px 62px',
                        border: 'none',
                        cursor: 'pointer',
                    }}  >Eliminar descargable</Button>
                </div>


                
               {/* <TextField label="Titulo" variant='outlined' value={formDataDescargable.titulo} name="titulo" onChange={onChangeDescargable} style={{ background: '#fff' }}  />

                <TextField label="Descripcion Breve" variant='outlined' value={formDataDescargable.descripcion_breve} name="descripcion_breve" onChange={onChangeDescargable} style={{ background: '#fff' }}  />
                <CustomInputFile label='Imagen thumb (848 x 566px)' onChange={e => {
                    setImagesDescargable(prev => ({
                        ...prev,
                        imgThumb: e.target.files ? e.target.files[0] : undefined
                    }))
                    }} img={formDataDescargable.path_img_thumb} />

                <CustomInputFile type='pdf' label='PDF' accept='*' onChange={e => {
                    setImagesDescargable(prev => ({
                        ...prev,
                        uploadPDF: e.target.files ? e.target.files[0] : undefined
                    }))
                }} img={formDataDescargable.path_descargar_pdf} />*/}

                <Autocomplete
                    disabled={formData.labelDescargable === 'Descargables'}
                    options={descargablesFiltrados.sort((a, b) => a.titulo.localeCompare(b.titulo))}
                    getOptionLabel={(option) => `${option.titulo}`}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    value={descargablesFiltrados.find(d => d.id === formData.idDescargable) || null}
                    onChange={(event, newValue) => {
                        setFormData(prev => ({
                            ...prev,
                            idDescargable: newValue?.id || ''
                        }))
                    }}
                    onInputChange={(event, newInputValue) => {
                        setBusquedaDescargable(newInputValue)
                    }}
                    inputValue={busquedaDescargable}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Descargable"
                            variant="outlined"
                            placeholder="Buscar descargable..."
                            style={{ background: '#fff' }}
                        />
                    )}
                    renderOption={(props, option) => (
                        <Box component="li" {...props} key={option.id}>
                            <Box>
                                <div style={{ fontWeight: 'bold' }}>{option.titulo}</div>
                            </Box>
                        </Box>
                    )}
                    noOptionsText="No se encontraron descargables"
                    clearOnEscape
                    selectOnFocus
                    handleHomeEndKeys
                />

                <div className='mb-4 flex items-center'>
                    <p className=' font-normal'>Personalizado</p>
                    <Checkbox checked={checkPersonalizado} onChange={() => setCheckPersonalizado(!checkPersonalizado)} />
                </div>


                <FormControl>
                   {(!checkPersonalizado) ?<>
                    <InputLabel >Label Descargable</InputLabel>
                    <Select  name="labelDescargable" onChange={onChange} value={formData.labelDescargable}>
                            <MenuItem value="">Selecciona un label</MenuItem>
                            {LABELS_DESCARGABLES.map((categoria, index) => (
                                <MenuItem key={index} value={categoria}>{categoria}</MenuItem>
                            ))}
                        </Select>  </>
                    : <TextField label="Label personalizado" name="labelDescargable" onChange={onChange} value={formData.labelDescargable} />}
                </FormControl>

                {formData.labelDescargable === 'Descargables' && <FormControl>
                    <InputLabel >Descargable</InputLabel>
                    <Select  name="descargableCategoria" onChange={onChange} value={formData.descargableCategoria}>
                        <MenuItem value="">Selecciona una categoria</MenuItem>
                        {CATEGORIAS_DESCARGABLES.map((categoria, index) => (
                            <MenuItem key={index} value={categoria}>{categoria}</MenuItem>
                        ))}
                    </Select>
                </FormControl>}

                {loading && <div>Cargando Espere...</div>}


                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', }}>
                    <Button color="success" variant="contained" type='submit' disabled={loading} style={{
                        background: '#000',
                        fontFamily: 'WorkSans',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '16px',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        color: '#FFF',
                        padding: '17px 62px',
                        border: 'none',
                        cursor: 'pointer',
                    }}  >Guardar</Button>
                    
                    <Button color="error" variant="contained"  disabled={loading} onClick={() => {
                        navigate("/productos")
                    }} style={{
                        background: '#D8D8D8',
                        fontFamily: 'WorkSans',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '16px',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        color: '#5E5E5E',
                        padding: '17px 62px',
                        border: 'none',
                        marginLeft: '20px',
                        cursor: 'pointer',
                    }}>Cancelar</Button>
                </div>

            </Box>
        </>

    )
}

export default ProductoAdd